import { FC, useEffect, useRef } from "react";
import useAuthStore from "../../../store/AuthStore";
import { authApi } from "@src/api/auth";
import { emitSessionLost, OMEGA_TOKEN_EXPIRED_CODE } from "./sessionEvents";

/** Интервал проверки токена (мс). */
const TOKEN_CHECK_INTERVAL_MS = 180 * 1000;

function isTokenExpiredError(error: unknown): boolean {
    if (!(error instanceof Error)) {
        return false;
    }
    return error.message.includes(String(OMEGA_TOKEN_EXPIRED_CODE)) || error.message.includes("авторизац");
}

/**
 * Периодически проверяет валидность токена для авторизованного пользователя.
 */
export const TokenChecker: FC = () => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        const validateToken = (): void => {
            void authApi.checkTokenValidity().catch((error: unknown) => {
                if (isTokenExpiredError(error)) {
                    emitSessionLost({
                        reason: "token-check-failed",
                        source: "TokenChecker",
                    });
                    return;
                }
                console.error("Не удалось проверить валидность токена", error);
            });
        };

        if (!isAuthenticated) {
            return undefined;
        }

        intervalRef.current = setInterval(validateToken, TOKEN_CHECK_INTERVAL_MS);

        return () => {
            if (intervalRef.current != null) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [isAuthenticated]);

    return null;
};
